// action - state management
import { FETCH_MASKED_MFA_METHODS, FETCH_USER_INFO, LOGIN, LOGOUT, MFA_CHALLENGE, MFA_REQUIRED, REGISTER } from './actions';

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  user: null
};

// eslint-disable-next-line
const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGIN: {
      const { user, isp, role } = action.payload;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user,
        isp,
        role
      };
    }
    case MFA_REQUIRED: {
      const { verificationToken, rememberUserAgent, email } = action.payload;
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        email,
        verificationToken,
        rememberUserAgent
      };
    }
    case MFA_CHALLENGE: {
      const { mfaMethod } = action.payload;
      return {
        ...state,
        mfaMethod
      };
    }
    case FETCH_MASKED_MFA_METHODS: {
      const { maskedMfaMethods } = action.payload;
      return {
        ...state,
        maskedMfaMethods
      };
    }
    case FETCH_USER_INFO: {
      const { user } = action.payload;
      return {
        ...state,
        user
      };
    }
    case LOGOUT: {
      return {
        ...state,
        isInitialized: true,
        isLoggedIn: false,
        user: null,
        isp: null
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default accountReducer;
